import useApi from '../../../services/useApi'
import useFilters from '../../../hook/useFilters'

const useGetCustomerChurn = () => {
  const Api = useApi()

  const initialFilters = {
    search: '',
    page: 1,
    limit: 30,
    sort_by: 'created_at/-1',
  }

  const {filters, onSearch, onSortingChange, onPageChange} = useFilters(initialFilters, {
    sortType: 'number',
  })

  const {data: response, isFetching} = Api.useGetQuery('/analytics/customer-churn-report', {
    queryId: 'customer-churn-list',
    filters: filters,
    isToast: false,
    isErrorPageRedirection: false,
  })

  return {
    customers: response?.data || [],
    isLoading: isFetching,
    onSearch,
    onSortingChange,
    onPageChange,
    pagination: response?.meta?.pagination || {},
  }
}

export default useGetCustomerChurn
